import http from 'hub-http/clients/apiClient';
const root = 'product-updates';
const userFavoriteRolloutsRoot = `${root}/v3/user-favorite-rollouts`;
export const FavoriteAPI = {
  addFavorite: ({
    rolloutId
  }) => http.post(`${userFavoriteRolloutsRoot}/${rolloutId}`),
  removeFavorite: ({
    rolloutId
  }) => http.delete(`${userFavoriteRolloutsRoot}/${rolloutId}`)
};